import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Manager", value: "Manager" },
  { label: "Staff", value: "Staff" },
  // Add other departments as needed
];

const onRollData = [
  { sno: 1, category: "Admin", maleTN: 3, maleOther: 0, femaleTN: 5, femaleOther: 0, total: 8 },
  { sno: 2, category: "Manager", maleTN: 8, maleOther: 0, femaleTN: 1, femaleOther: 0, total: 9 },
  { sno: 3, category: "Staff", maleTN: 13, maleOther: 0, femaleTN: 5, femaleOther: 0, total: 18 },
];

const presentData = [
  { sno: 1, category: "Admin", male: 3, female: 5, total: 8 },
  { sno: 2, category: "Manager", male: 8, female: 1, total: 9 },
  { sno: 3, category: "Staff", male: 13, female: 5, total: 18 },
];

const onRollColumns = [
  { Header: "S No", Cell: ({ row }) => onRollData.length - row.index, className: "serial-no text-center", },
  { Header: "Category", accessor: "category" },
  {
    Header: "Male", columns: [
      { Header: "TN", accessor: "maleTN", sum: true },
      { Header: "Other State", accessor: "maleOther", sum: true },
    ]
  },
  {
    Header: "Female", columns: [
      { Header: "Female TN", accessor: "femaleTN", sum: true },
      { Header: "Female Other State", accessor: "femaleOther", sum: true },
    ]
  },

  { Header: "Total", accessor: "total", sum: true },
];

const presentColumns = [
  { Header: "S No", Cell: ({ row }) => presentData.length - row.index, className: "serial-no text-center", },
  { Header: "Category", accessor: "category" },
  { Header: "Male", accessor: "male", sum: true },
  { Header: "Female", accessor: "female", sum: true },
  { Header: "Total", accessor: "total", sum: true },
];

const RecruitmentReportOnRoll = () => {
  const [viewOption, setViewOption] = useState("OnRoll");

  const formik = useFormik({
    initialValues: {
      department: null,
      date: "",
    },
    validationSchema: Yup.object({
      date:Yup.string().required("Date is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Recruitment" breadcrumbItem={viewOption} />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={val => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="date"
                    value={formik.values.date}
                    onChange={val => formik.setFieldValue("date", val)}
                    onBlur={() => formik.setFieldTouched("date", true)}
                  />

                  {formik.touched.date && formik.errors.date ? (
                    <div className="text-danger">{formik.errors.date}</div>
                  ) : null}
                </Col>
                <Col md={4}>
                  <div className="d-flex align-items-center gap-3 mt-md-4 pt-md-2">
                    <div>
                      <input
                        type="radio"
                        id="onroll"
                        name="viewOption"
                        value="OnRoll"
                        checked={viewOption === "OnRoll"}
                        onChange={() => setViewOption("OnRoll")}
                      />
                      <Label htmlFor="onroll" className="mb-0 ms-1">OnRoll</Label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="present"
                        name="viewOption"
                        value="Present"
                        checked={viewOption === "Present"}
                        onChange={() => setViewOption("Present")}
                        className="ms-3"
                      />
                      <Label htmlFor="present" className="mb-0 ms-1">Present</Label>
                    </div></div>
                </Col>
                <Col className="d-flex mob-center justify-content-end gap-2 flex-wrap align-items-center">
                  <Button type="submit" className="btn button-search"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print"><i className="fas fa-print me-1" /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="timesheet-summary hoursheet p-2 mb-0 ">
              <p className="mb-0"><strong>Employee {viewOption} Report</strong></p>
            </div>
            <TableContainerColumnTotal
              columns={viewOption === "OnRoll" ? onRollColumns : presentColumns}
              data={viewOption === "OnRoll" ? onRollData : presentData}
              isGlobalFilter={false}
              customPageSize={10}
              tableSorter={false}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default RecruitmentReportOnRoll;
